/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
// import routes from "routes.js";
import useRoutes from "config/useRoutes";
import { useSelector } from "react-redux";
import FreeCard from "./components/SidebarCard";
import { useTranslation } from "react-i18next";

const Sidebar = ({ open, onClose }) => {
  const routes = useRoutes();
  const language = useSelector((state) => state?.user?.language);
const {t} = useTranslation();
  console.log("localizedRoutes", routes);
  return (
    <div className={`custom-scrollbar sm:none duration-175 linear fixed !z-50 flex max-h-full min-h-full flex-col overflow-y-auto bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[20px] flex items-center`}>
        <div className="ml-1 mt-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-navy-700 dark:text-white">
          {t("Iwash")}
        </div>
      </div>
      <div class="mb-7 mt-[58px] h-px bg-gray-300 dark:bg-white/30" />
      <ul className="mb-auto pt-1">
        <Links routes={routes?.filter((route) => route?.name !== "Sign In" && route?.name !== "Forget-Password" && route?.name !== "Verify-Otp" && route?.name !== "Reset-Password" && route?.name !== "RTL Dashboard")}/>
      </ul>
      <FreeCard />
    </div>
  );
};

export default Sidebar;
